import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Save, Eye } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { AdminTitle } from "@/admin/AdminLayout";
import { Field } from "@/admin/FormDialog";
import { Switch } from "@/components/ui/switch";

export default function AdminVault() {
  const { settings, refresh } = useSite();
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (settings.site_title !== undefined && !f) setF(settings); }, [settings, f]);
  if (!f) return null;
  const set = (p) => setF((x) => ({ ...x, ...p }));
  const save = async () => {
    setBusy(true);
    try { await api.put("/settings", f); await refresh(); toast.success("Royal Vault saved"); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div data-testid="admin-vault">
      <AdminTitle eyebrow="Future merchandise" title="The Royal Vault">
        <Link to="/vault" target="_blank" data-testid="vault-preview-link" className="btn-ghost-illum"><Eye className="w-4 h-4" /> View page</Link>
        <button onClick={save} disabled={busy} data-testid="vault-save-button" className="btn-illum theme-flame disabled:opacity-60"><Save className="w-4 h-4" /> {busy ? "Saving…" : "Save"}</button>
      </AdminTitle>
      <section className="vellum p-6 grid gap-5 max-w-3xl">
        <label className="flex items-center justify-between gap-4">
          <span>
            <span className="font-heading text-sm font-bold block">Show the Vault in the site menu</span>
            <span className="text-sm italic text-[#5e4a35]">When on, readers see a “Vault” link in the header. The page itself is always at /vault.</span>
          </span>
          <Switch data-testid="settings-vault-switch" checked={!!f.vault_enabled} onCheckedChange={(v) => set({ vault_enabled: v })} />
        </label>
        <Field label="Vault heading"><input data-testid="vault-title-input" value={f.vault_title || ""} onChange={(e) => set({ vault_title: e.target.value })} className="admin-input" /></Field>
        <Field label="Vault message"><textarea rows={4} data-testid="vault-message-input" value={f.vault_message || ""} onChange={(e) => set({ vault_message: e.target.value })} className="admin-input" /></Field>
        <p className="text-sm italic text-[#5e4a35]">When you're ready to sell merchandise, products and checkout can be added to this page.</p>
      </section>
    </div>
  );
}
